import Vue from 'vue';

export class WorkspaceDetailsParams {
  resourceGroupName: string;
  subscriptionId: string;
  storageName: string;

  constructor(data: any) {
    this.resourceGroupName = data.resourceGroupName;
    this.subscriptionId = data.subscriptionId;
    this.storageName = data.storagename;
  }
}

export class Helper {
  static enableLog: boolean = false;

  static errorToaster = (message: string) => {
    Vue.swal({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      type: "error", //TODO test
      text: message
    })
  }
  static successToaster = (message: string) => {
    Vue.swal({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      type: "success", //TODO test
      text: message
    })
  }

  static formatDate = (date: Date) => {
    date = new Date(date);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    return dd + "-" + mm + "-" + yyyy;
  }

  static formatMoney = (money: number) => {
    return money ? `€${money.toFixed(2).replace(".", ",")}` : "€0";
  }

  static timeout(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  static pad2(n: number): string {
    const s = "" + n;
    return s.padStart(2, "0");
  }

  static pad3(n: number): string {
    const s = "" + n;
    return s.padStart(3, "0");
  }

  static ticksToTime(ticks: number, usems?: boolean): string {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60;
    const seconds = ticks / 1000 - offset;
    const hour = Math.floor((seconds / 3600) % 24);
    const minute = Math.floor((seconds / 60) % 60);
    const second = Math.floor(seconds % 60);
    const ms = Math.floor(ticks % 1000);
    if (!!usems)
      return this.pad2(minute) + ":" + this.pad2(second) + "." + this.pad3(ms);
    return this.pad2(hour) + ":" + this.pad2(minute) + ":" + this.pad2(second);
  }

  static log(...args: any[]) {
    if (this.enableLog || process.env.NODE_ENV === "development")
      console.debug(this.ticksToTime(Date.now(), true), ...args);
  }
}

import {ConvertableFromApi} from '../models/ConvertableFromApi';

export class ApiConversionHelperService {

  static convertFromApiArray<T extends ConvertableFromApi<T>>(model: T, array: any[]): T[] {
    let list: Array<T> = new Array<T>();
    if (array !== null && array !== undefined && array.length > 0) {
      for (let index: number = 0; index < array.length; index++) {
        list.push(model.createNew(array[index]));
      }
    }
    return list;
  }

  convertFromApiModel<T extends ConvertableFromApi<T>>(model: T, data: any): T {
    return model.createNew(data);
  }
}